enum ClientProfileTab {
  PersonalDetails = 'personal-details',
  HealthDetails = 'health-details',
  CommunityEngagement = 'community-engagement',
  CollateralContacts = 'collateral-contacts',
  TreatmentPlans = 'treatment-plans',
  Documents = 'documents',
}

const legacyTabOrder = [
  ClientProfileTab.PersonalDetails,
  ClientProfileTab.HealthDetails,
  ClientProfileTab.CollateralContacts,
  ClientProfileTab.TreatmentPlans,
  ClientProfileTab.Documents,
];

const tabKeys: string[] = Object.values(ClientProfileTab);

const isClientProfileTab = (value: string): value is ClientProfileTab => tabKeys.includes(value);

export const toClientProfileTab = (value: string | number | null | undefined): ClientProfileTab => {
  if (value === null || value === undefined) return ClientProfileTab.PersonalDetails;

  const text = String(value);
  if (isClientProfileTab(text)) return text;

  return legacyTabOrder[Number(text)] ?? ClientProfileTab.PersonalDetails;
};

export default ClientProfileTab;
